import React, { useContext, useEffect, useState } from 'react';
import Accordian from 'atoms/Accordian/Accordian';
import { ReorderConstants, CANCEL } from '../Constants/ReorderConstants';
import _get from 'lodash/get';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import { useSelector, useDispatch } from 'react-redux';
import ImageComponent from 'atoms/Image';
import { useHistory } from 'react-router';
import { reorderFetchMenuAction } from '@kfc-global/react-shared/redux/Actions/ReorderAction';

import {
  addItemToCartAction,
  createBasketsAction,
  resetBasketAction,
  qrCodeScanTimeAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';

import { quickReorderAnalyticFn, reOrderAnalyticHandlerFn, setAnalyticsData } from '../ReorderUtils/ReorderUtils';
import { dateIsBetween, getCurrentDateTimeInUnix } from 'common/utilities/dayJsUtils';
import { ChannelManager } from 'common/manager';
import { UserOrderContext } from 'context/context';
import {
  getAndCheck,
  getDispositionFomat,
  getFilteredItems,
  getFullAddressDetails,
  isEmptyEvery,
  getValueOrDefaultObject,
  DeliveryAddresslines,
  getValueOrEmptyString,
  getTernaryValue,
  getAndCheckIfOneTrue,
  getCheckIfAnyOnePass,
  isQRModeCheck,
  getEmptyObjectforNull,
} from 'common/utilities/utils';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import SCHEDULE_ORDER_SAMPLE_DATA from 'organisms/ScheduleOrder/Data/SampleData';
import { quantity, setAddHopeCarryBagInfo } from 'organisms/PaymentProcess/Presentation/orderReceivedScreenFn';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const {
  DELIVER_TO,
  TOTAL,
  DISCOUNT,
  SUBTOTAL,
  WHEN,
  PLEASE_REVIEW_YOUR_ORDER,
  TODAY,
  ASAP,
  ITEMS,
  WANT_TO_MODIFY,
  ITEM_ADDED_TO_CART_MSG,
  KEEP_SHOPING,
  ADD_A_COUPON,
  CONTINUE_TO_PAYMEN,
  PRICE_CHANGE_MAIN,
  PRICE_CHANGE_TEXT,
  UNAVAILABLE,
  TAKEAWAY,
  DINE_IN_TEXT,
  STORE_CLOSED,
  GENERIC_ERROR,
  GST,
  CLOSED,
  SET_DISPOSITION,
  SEARCH_IN_CART,
  LARGE_CARRY_BAG,
  ADD_HOPE_TEXT,
  DISPOISTIONUN_AVAL,
  UNAVAILABLE_ERROR,
  QUICK_ORDER,
  SCHEDULE_ORDER_DATA,
  CHANGE_ORDER_SETTING,
} = ReorderConstants;

export function checkTypeOfError(
  errors,
  storeStatus,
  Errordata,
  unavailableItemCount,
  priceChangedItemCount,
  summary,
  clickedOrderDisposition,
) {
  let isPriceChange = false;
  let error = '';
  if (!storeStatus) {
    error = Errordata;
  } else if (errors.length > 0) {
    error = translateWithI18Next(GENERIC_ERROR);
  } else if (unavailableItemCount > 0) {
    error = translateWithI18Next(UNAVAILABLE_ERROR);
  } else if (priceChangedItemCount > 0) {
    error =
      priceChangedItemCount +
      ' ' +
      translateWithI18Next(PRICE_CHANGE_TEXT) +
      ' ' +
      translateWithI18Next(PRICE_CHANGE_MAIN);
    isPriceChange = true;
  } else if (summary === null) {
    const dispositionUnavailable = translateWithI18Next(DISPOISTIONUN_AVAL);
    error = dispositionUnavailable?.replace('%disposition%', getDispositionFomat(clickedOrderDisposition));
  }
  return { error, isPriceChange };
}

function checkForCreateBasket(isBasketAdded, createBaskets, filteredItems, summary, storeStatus) {
  //----- Below commented lines Related to [RENDEV-919] PWA | Re-order notification. commented due to descope in release-oct
  // if (!isBasketAdded && summary !== null && storeStatus) {
  if (!isBasketAdded) {
    createBaskets(filteredItems);
  }
}
function dispatchAddToCartFunc(dispatch, response, foodLineInfo, basketId, tenantId, setIsItemAddedInCart) {
  if (response.unAval !== foodLineInfo.length) {
    dispatch(
      addItemToCartAction(
        {
          params: {
            basketId,
          },
          tenantId,
        },
        response.itemArr,
        () => setIsItemAddedInCart(true),
      ),
    );
  }
}
const QuickReorderModal = props => {
  const { onCancel, onContinue, onAddCoupon, storeInfo = {}, isBasketAdded } = props;
  const { summary = {}, service: clickedOrderDisposition = '' } = storeInfo;
  const { status = {} } = getValueOrDefaultObject(summary);
  const { currentStatus = '' } = getValueOrDefaultObject(status);
  const storeStatus = currentStatus === CLOSED ? false : true;
  const dispatch = useDispatch();
  const [unavailableItemCount, setUnavailableItemCount] = useState(0);
  const [priceChangedItemCount, setPriceChangedItemCount] = useState(0);
  const [isError, setIsError] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [errorMsg, setErrorMsg] = useState();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { Error } = IMAGE_PATH;
  const [carryBagDataExistsId, setCarryBagDataExistsId] = useState('');
  const [addHopeDataExistsId, setAddHopeDataExistsId] = useState('');
  const [addHopeDataPrice, setAddHopeDataPrice] = useState(0);
  const [carryBagDataPrice, setCarryBagDataPrice] = useState(0);
  const [foodLineItem, setFoodLineItem] = useState([]);
  const [flag, setFlag] = useState(false);
  const [basketId, setBasketId] = useState(false);
  const [reOrderAnalyticEvent, setReOrderAnalyticEvent] = useState(false);
  const [isItemAddedInCart, setIsItemAddedInCart] = useState(false);

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;

  const { tenantReducer, postOrderReducer, reorderReducer, cartReducer, profileReducer, appStateReducer } = useSelector(
    data => {
      return data;
    },
  );
  const { flatResponse: { itemMapById: menuItemsMapById = {} } = {} } =
    useSelector(({ menuReducer }) => menuReducer) ?? {};
  let template = translateWithI18Next(STORE_CLOSED);
  let Errordata = template?.replace('%storeName%', summary?.name);
  const history = useHistory();
  const { cartData = {}, qrCodeScanTime } = getValueOrDefaultObject(cartReducer);
  const { errors = [] } = getValueOrDefaultObject(cartData);
  const { tenantId, currencySymbol, currencyConversionFactor, addHope, carryBag } = tenantReducer;
  const { orderAccepted: orderDetails = {} } = getValueOrDefaultObject(postOrderReducer);
  const { flatResponse } = reorderReducer;
  const { items: flatResItems = [] } = getValueOrDefaultObject(flatResponse);
  const { flatResponse: { itemMapById = {}, categoryMapById = {} } = {} } = getEmptyObjectforNull(reorderReducer);
  const { customerId } = profileReducer;
  const { timingsSampleData } = SCHEDULE_ORDER_SAMPLE_DATA;
  const { userStatus: userParams } = getValueOrDefaultObject(appStateReducer);
  const {
    deliveryAddress = {},
    foodLines = [],
    subTotal,
    total,
    taxLines = [],
    additionalChargeLines = [],
    store: storeDetails = {},
    service: disposition = '',
    lang = '',
    source = '',
    catalog = '',
    inclusiveTaxTotal,
    discountTotal,
  } = orderDetails;
  const { storeId = '', address = {} } = getValueOrDefaultObject(storeDetails);

  const selectedStoreInfo = {
    ...storeInfo,
    ...storeDetails,
    id: storeId,
    addresses: [
      {
        address: {
          addressLines: [getFullAddressDetails(address)],
        },
        lang,
      },
    ],
    name: [
      {
        lang: lang,
        value: storeDetails.name,
      },
    ],
  };

  useEffect(() => {
    let addHopeCarryBag = getAndCheck(addHope, carryBag);
    if (addHopeCarryBag) {
      let setAddHopeObj = { setAddHopeDataExistsId, setAddHopeDataPrice };
      let setCarryBagObj = { setCarryBagDataExistsId, setCarryBagDataPrice };
      setAddHopeCarryBagInfo(
        orderDetails,
        addHope,
        carryBag,
        SEARCH_IN_CART,
        setAddHopeObj,
        setCarryBagObj,
        tenantReducer,
      );
      let filteredItems = getFilteredItems(foodLines, addHope, carryBag);
      setFoodLineItem(filteredItems);
      checkForCreateBasket(isBasketAdded, createBaskets, filteredItems, summary, storeStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails]);

  const getDescription = data => {
    const modGroups = _get(data, 'modGrps', []);
    const modifiersDetails = modGroups.map(o => o.modifiers).flat();
    return modifiersDetails.map(item => ` ${item.quantity}x ${item.name}`).join();
  };
  const categoryArray = (itemArr, newItem, product, categoryMapByIdInfo) => {
    const { id = '', name = '', url = '' } = categoryMapByIdInfo?.[product?.categoryId] ?? {};
    return itemArr.push({
      Id: newItem.item.id,
      quantity: newItem.quantity,
      categoryUrl: url,
      categoryName: name,
      categoryId: id,
    });
  };
  const checkAvailability = foodLineInfo => {
    const itemArr = [];
    let unAval = 0;
    let costChange = 0;
    foodLineInfo?.forEach(newItem => {
      const { isAvailable, product } = checkProductPriceAndAvail(newItem.item.id, itemMapById);
      if (isAvailable?.toString() !== 'hidden') {
        if (!isAvailable) {
          unAval = unAval + 1;
        } else if (isAvailable && isAvailable !== newItem.unitPrice) {
          costChange = costChange + 1;
          categoryArray(itemArr, newItem, product, categoryMapById);
        } else {
          categoryArray(itemArr, newItem, product, categoryMapById);
        }
      }
    });
    setUnavailableItemCount(unAval);
    setPriceChangedItemCount(costChange);
    return { unAval, itemArr };
  };

  const fetchMenuSuccessCallback = foodLineInfo => {
    dispatch(resetBasketAction());
    const response = checkAvailability(foodLineInfo);
    dispatchAddToCartFunc(dispatch, response, foodLineInfo, basketId, tenantId, setIsItemAddedInCart);
    const { futureDates, scheduled: initiallyScheduled, asap } = summary?.timings || timingsSampleData;
    const { interval: initialInterval = 0, startEndTime = {} } =
      (initiallyScheduled?.periods?.length && initiallyScheduled.periods[0]) || {};
    const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;

    getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      futureDates.length === 1 && tenantReducer?.country === 'INDIA',
    );

    let dateTimeObj = {
      time: 'ASAP',
      interval: selectedStoreInfo?.summary?.timings?.scheduled?.periods[0]?.interval,
      date: new Date(),
      selectedTime: 'ASAP',
    };

    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
    const deliveryAddressInfo = `${deliveryAddress?.addressLines?.join('')} ${deliveryAddress?.city} ${
      deliveryAddress?.state
    } ${deliveryAddress?.country}`;

    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        newValue: {
          type: getDispositionFomat(disposition),
          store: selectedStoreInfo,
          date: dateTimeObj.date,
          time: dateTimeObj.time,
          interval: dateTimeObj.interval,
          selectedTime: dateTimeObj.selectedTime,
          deliveryAddress: deliveryAddressInfo,
        },
        oldvalue: dispositionNew,
      },
    });
    localStorage.setItem(
      'dispositionNew',
      JSON.stringify({
        type: getDispositionFomat(disposition),
        store: selectedStoreInfo,
        time: dateTimeObj.time,
        date: dateTimeObj.date,
        selectedTime: dateTimeObj.selectedTime,
        interval: dateTimeObj.interval,
        deliveryAddress: deliveryAddressInfo,
      }),
    );
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
  };

  const fetchReorderMenuIfBasketAdded = foodLineItemVal => {
    dispatch(
      reorderFetchMenuAction(
        {
          tenantId,
          catalogName: catalog,
        },
        { storeId, channel: ChannelManager.channel, service: disposition },
        () => setFlag(true),
      ),
    );
  };

  useEffect(() => {
    if (flag) {
      setFlag(false);
      fetchMenuSuccessCallback(foodLineItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemMapById, foodLineItem, flag, isBasketAdded]);

  const createBaskets = filteredItems => {
    const payload = {
      storeId: getValueOrEmptyString(storeId),
      service: disposition,
      channel: ChannelManager.channel,
      requestedDateTime: {
        isForNow: true,
        futureDateTime: 0,
      },
      customerId,
      deliveryAddress: {
        ...deliveryAddress,
        name: getValueOrEmptyString(deliveryAddress?.name),
        pinCode: getValueOrEmptyString(deliveryAddress?.pinCode),
      },
      catalog,
      lang,
      source,
    };

    const isQRmode = isQRModeCheck(qrCodeScanTime);
    const selectedStoreId = localStorage.getItem(LOCAL_STORAGE_KEYS.STORE_ID);
    const selectedDisposition = localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE)?.toLowerCase();

    if (
      isQRmode &&
      qrCodeScanTime &&
      payload?.storeId === selectedStoreId &&
      payload?.service === selectedDisposition
    ) {
      payload.qrOrder = {
        isQROrder: true,
        qrScannedTime: qrCodeScanTime,
      };
    } else {
      dispatch(qrCodeScanTimeAction(''));
    }
    dispatch(
      createBasketsAction({
        data: payload,
        tenantId,
        successCallback: null,
        errorCallback: () => checkAvailability(filteredItems),
      }),
    );
  };

  useEffect(() => {
    if (isBasketAdded) {
      const { id: basket_id } = cartData;
      setBasketId(basket_id);
      fetchReorderMenuIfBasketAdded(foodLineItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBasketAdded, foodLineItem]);

  const keepShopingHandler = () => {
    setAnalyticsData('keepShopping');
    reOrderAnalyticHandlerFn(currencyConversionFactor, reOrderObj);
    history.push({ pathname: '/menu' });
    /* resetting false value to reorderClick, to show the toast onclick add to cart button*/
    sessionStorage.setItem('reorderClick', false);
  };

  const checkProductPriceAndAvail = (id, itemMapByIds) => {
    let isAvailableProduct = false;
    const scheduledTime = getCurrentDateTimeInUnix();
    const product = getEmptyObjectforNull(itemMapByIds?.[id]);
    //RENDEV-11031 getting product as an object => replaced product[0] to product
    const availableHours = product?.availability?.[0]?.availableHours;
    const startTime = availableHours?.startTime.time;
    const endTime = availableHours?.endTime.time;
    isAvailableProduct = dateIsBetween(scheduledTime, startTime, endTime);
    const hiddenItem = product?.isHidden;
    if (hiddenItem) {
      isAvailableProduct = 'hidden';
    }
    if (isAvailableProduct) {
      isAvailableProduct = product?.availability[0]?.price;
    }
    return { isAvailable: isAvailableProduct, product: product };
  };
  const reOrderObj = { foodLineItem, checkProductPriceAndAvail, itemMapById, reOrderAnalyticEvent, menuItemsMapById };
  useEffect(() => {
    let errorInfo = checkTypeOfError(
      errors,
      storeStatus,
      Errordata,
      unavailableItemCount,
      priceChangedItemCount,
      summary,
      clickedOrderDisposition,
    );
    const isUnavilable = getAndCheck(unavailableItemCount > 0, unavailableItemCount !== foodLineItem.length);
    if (isItemAddedInCart) {
      setDisableBtn(
        getTernaryValue(getAndCheckIfOneTrue(errorInfo.isPriceChange, isUnavilable), false, errorInfo.error !== ''),
      );
    }
    setReOrderAnalyticEvent(
      getTernaryValue(getCheckIfAnyOnePass(errorInfo.isPriceChange, isUnavilable, errorInfo.error === ''), true, false),
    );
    setIsError(errorInfo.error !== '');
    setErrorMsg(errorInfo.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flatResItems, unavailableItemCount, priceChangedItemCount, storeStatus, errors, summary, isItemAddedInCart]);

  useEffect(() => {
    quickReorderAnalyticFn(isError, QUICK_ORDER, errorMsg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  const thousands_separators = amount => amount.toFixed(2);

  return (
    <>
      <div className='ReorderModal'>
        <div className='reorder-header'>
          <span className='your-order'>{translateWithI18Next(PLEASE_REVIEW_YOUR_ORDER)}</span>
        </div>
        {isError && (
          <div className='error-container'>
            <div className='error-sub-container'>
              <div>
                <ImageComponent srcFile={Error} className='location-alert-icon mr-1' />
                <div className='error-msg'>{errorMsg}</div>
              </div>
            </div>
          </div>
        )}
        <hr className='horizontal-bar' />
        <div className='reorder-order-detail'>
          {disposition.toLowerCase() === 'delivery' && (
            <div className='reorder-details-heading'>
              <span className='reorder-sub-heading'>{translateWithI18Next(DELIVER_TO)}</span>
              <span className='reorder-sub-detail width-style-lg'>{DeliveryAddresslines(deliveryAddress)}</span>
            </div>
          )}
          {disposition.toLowerCase() !== 'delivery' && (
            <div className='reorder-details-heading'>
              <span className='reorder-sub-heading'>
                {disposition.toLowerCase() === 'dine-in' && translateWithI18Next(DINE_IN_TEXT)}
                {disposition.toLowerCase() === 'pickup' && translateWithI18Next(TAKEAWAY) + ' FROM'}
              </span>
              <span className='reorder-sub-detail width-style-lg'>{getFullAddressDetails(address)}</span>
            </div>
          )}
          <div className='reorder-details-heading'>
            <span className='reorder-sub-heading'>{translateWithI18Next(WHEN)}</span>
            <span className='reorder-sub-detail width-style'>
              {translateWithI18Next(TODAY)} {translateWithI18Next(ASAP)}
            </span>
          </div>
        </div>
        <section className='reorder-accordian'>
          <div className='mt-2'>
            <Accordian header={`${quantity(foodLineItem)} ${ITEMS}`} data-testid={`order-details`}>
              {foodLineItem.map(itemInfo => {
                const { isAvailable } = checkProductPriceAndAvail(itemInfo.item.id, itemMapById);
                return (
                  <section className=''>
                    <div className='reorder-order-item'>
                      <div className='reorder-item-details mt-2'>
                        <div className='item-count-box mr'>
                          <span className='item-count ml'>{itemInfo.quantity}</span>
                        </div>
                        <div className='item-desc-section'>
                          <span className='item-desc'>{itemInfo?.item?.name}</span>
                          <span className='item-desc-quantity'>{getDescription(itemInfo?.item)}</span>
                        </div>
                      </div>
                      {!isAvailable && (
                        <div className='unavialble-alert'>
                          <ImageComponent srcFile={Error} className='location-alert-icon' />
                          <span className='alert-text'>{translateWithI18Next(UNAVAILABLE)}</span>
                        </div>
                      )}
                      {isAvailable && isAvailable !== itemInfo.unitPrice && (
                        <div className='cart-item-price'>
                          <span className='old-price'>
                            {currencySymbol}
                            {thousands_separators(itemInfo.unitPrice / currencyConversionFactor)}
                          </span>
                          <span className='modified-price'>
                            {currencySymbol}
                            {thousands_separators(isAvailable / currencyConversionFactor)}
                          </span>
                        </div>
                      )}
                      {isAvailable === itemInfo.unitPrice && (
                        <span className='item-amount'>
                          {currencySymbol}
                          {thousands_separators(itemInfo?.item?.unitPrice / currencyConversionFactor)}
                        </span>
                      )}
                    </div>
                  </section>
                );
              })}
              <div className='reorder-modification-box mb-4'>
                <span className='reorder-heading mt-3'>{translateWithI18Next(WANT_TO_MODIFY)}</span>
                <span className='reorder-subheading mt-2'>{translateWithI18Next(ITEM_ADDED_TO_CART_MSG)}</span>
                <div className='reorder-modal-btn mt-3 mb-3'>
                  <ButtonComp
                    data-testid='keep-shoping-button'
                    className={`button whiteButton ${storeStatus ? 'blackBorder' : 'grayButton'}`}
                    onClickHandler={storeStatus ? keepShopingHandler : null}
                  >
                    {translateWithI18Next(KEEP_SHOPING)}
                  </ButtonComp>
                  <ButtonComp
                    data-testid='add-coupon-button'
                    className={`button whiteButton ${storeStatus ? 'blackBorder' : 'grayButton'}`}
                    onClickHandler={getTernaryValue(!storeStatus, null, () => {
                      onAddCoupon(currencyConversionFactor, reOrderObj, reOrderAnalyticHandlerFn);
                    })}
                  >
                    {translateWithI18Next(ADD_A_COUPON)}
                  </ButtonComp>
                </div>
              </div>
            </Accordian>
          </div>
        </section>
        <div className='reorder-order-detail'>
          <div className='reorder-payment-details'>
            <span className='payment-type'>{translateWithI18Next(SUBTOTAL)}</span>
            <span className='payment-amount'>
              {currencySymbol}
              {thousands_separators(subTotal / currencyConversionFactor)}
            </span>
          </div>
          {taxLines && (
            <div className='reorder-payment-details'>
              <span className='payment-type'>{GST}</span>
              <span className='payment-amount'>
                {currencySymbol}
                {thousands_separators(inclusiveTaxTotal / currencyConversionFactor)}
              </span>
            </div>
          )}
          {additionalChargeLines.map(charges => (
            <div className='reorder-payment-details'>
              <span className='payment-type'>{charges.chargeType}</span>
              <span className='payment-amount'>
                {currencySymbol}
                {thousands_separators(charges.amount / currencyConversionFactor)}
              </span>
            </div>
          ))}
          {discountTotal > 0 && (
            <div className='reorder-payment-details'>
              <span className='payment-type'>{translateWithI18Next(DISCOUNT)}</span>
              <span className='payment-amount'>
                – {currencySymbol}
                {thousands_separators(discountTotal / currencyConversionFactor)}
              </span>
            </div>
          )}
          {disposition.toUpperCase() === 'PICKUP' && carryBagDataExistsId && (
            <div className='reorder-payment-details' id='priceListData'>
              <span className='payment-type' id='fontStyle'>
                {translateWithI18Next(LARGE_CARRY_BAG)}
              </span>
              <span className='payment-amount' id='amountStyle'>
                {carryBagDataPrice}
              </span>
            </div>
          )}
          {Boolean(addHopeDataExistsId) && (
            <div className='reorder-payment-details' id='priceListData'>
              <span className='payment-type' id='fontStyle'>
                {translateWithI18Next(ADD_HOPE_TEXT)}
              </span>
              <span className='payment-amount' id='amountStyle'>
                {addHopeDataPrice}
              </span>
            </div>
          )}
          <div className='reorder-payment-details mt'>
            <span className='payment-total'>{translateWithI18Next(TOTAL)}</span>
            <span className='payment-total-amount'>
              {currencySymbol}
              {thousands_separators(total / currencyConversionFactor)}
            </span>
          </div>
        </div>
      </div>
      <div className='modal-footer'>
        <ButtonComp
          data-testid='quick-reorder-cancel'
          className='button whiteButton blackBorder cancel-btn btn-quick-order'
          onClickHandler={onCancel}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          data-testid='quick-order-continue-button'
          className={`button ${getTernaryValue(disableBtn, 'grayButton', 'redButton')} `}
          onClickHandler={getTernaryValue(disableBtn, null, () => {
            onContinue(currencyConversionFactor, reOrderObj, reOrderAnalyticHandlerFn);
          })}
        >
          {translateWithI18Next(CONTINUE_TO_PAYMEN)}
        </ButtonComp>
      </div>
    </>
  );
};

export default QuickReorderModal;
